import { Breadcrumbs } from "../../../AbstractElements";
import { Clipboards, FormWidgets } from "../../../Constant";
import { Container, Row } from "reactstrap";
import ClipboardOnTextInput from "./ClipboardOnTextInput";
import ClipboardOnTextarea from "./ClipboardOnTextarea";
import ClipboardOnParagraph from "./ClipboardOnParagraph";
import CopyPortionFromParagraph from "./CopyPortionFromParagraph";


const ClipboardContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Clipboards} parent={FormWidgets} title={Clipboards} />
      <Container fluid>
        <Row>
          <ClipboardOnTextInput />
          <ClipboardOnTextarea/>
          <ClipboardOnParagraph/>
          <CopyPortionFromParagraph/>
        </Row>
      </Container>
    </>
  );
};

export default ClipboardContainer;
